import { useCallback, useState } from 'react';

const KEY = 'v2Theme';

// 'dark' or 'light' for V2 only, remembered in this browser. The current site keeps its own setting (themeMode).
export const readMode = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (ex) { /* storage blocked: use the default */ }
  return 'dark';
};

export function useV2Theme() {
  const [mode, setMode] = useState(readMode);
  const toggle = useCallback(() => {
    setMode((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(KEY, next); } catch (ex) { /* not remembered */ }
      return next;
    });
  }, []);
  return [mode, toggle];
}
